export default __webpack_public_path__ + "static/media/flexview-logo.34d649d3.png";